'use strict';

/**
 * Product Tile Keyboard Navigation Module
 * Enables keyboard navigation for product tiles with tab, arrow keys, and enter/space interactions
 * Handles both regular grids and Slick carousel tiles
 */

module.exports = function () {
    var focusableSelector = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

    /**
     * Get all focusable elements within a tile
     */
    function getFocusableElements($tile) {
        return $tile.find(focusableSelector).filter(':visible');
    }

    /**
     * Check if the focused element is within a Slick carousel
     */
    function isInSlickCarousel($element) {
        return $element.closest('.slick-initialized').length > 0;
    }

    /**
     * Get the parent Slick carousel instance
     */
    function getSlickCarousel($element) {
        var $carousel = $element.closest('.slick-initialized');
        if ($carousel.length && $carousel.hasClass('slick-initialized')) {
            return $carousel.slick('getSlick');
        }
        return null;
    }

    /**
     * Get all visible product tiles (handles both regular grid and carousel)
     */
    function getAllVisibleTiles() {
        // Get all product tiles that are visible
        return $('.product-tile:visible');
    }

    /**
     * Handle keyboard events on product tiles
     */
    function handleTileKeydown(e) {
        var $tile = $(this);
        var $focusableElements = getFocusableElements($tile);
        var $activeElement = $(document.activeElement);
        var isElementInTile = $tile.find($activeElement).length > 0;

        if (!isElementInTile) {
            return;
        }

        switch (e.which) {
            // Enter key: activate focused element
            case 13: // Enter
                if ($activeElement.is('a')) {
                    $activeElement.click();
                    e.preventDefault();
                }
                break;

            // Space key: activate focused element
            case 32: // Space
                if ($activeElement.is('a, button')) {
                    $activeElement.click();
                    e.preventDefault();
                }
                break;

            // Up arrow: navigate to previous focusable element or previous tile
            case 38: // Up
                navigateToPreviousElement($tile, $focusableElements, e);
                break;

            // Down arrow: navigate to next focusable element or next tile
            case 40: // Down
                navigateToNextElement($tile, $focusableElements, e);
                break;

            // Left arrow: navigate to previous tile
            case 37: // Left
                navigateToPreviousTile($tile, e);
                break;

            // Right arrow: navigate to next tile
            case 39: // Right
                navigateToNextTile($tile, e);
                break;

            // Escape key: defocus and allow default behavior
            case 27: // Escape
                $activeElement.blur();
                break;
        }
    }

    /**
     * Navigate to previous focusable element within tile or previous tile
     */
    function navigateToPreviousElement($tile, $focusableElements, e) {
        if ($focusableElements.length === 0) {
            return;
        }

        var currentIndex = $focusableElements.index(document.activeElement);

        if (currentIndex > 0) {
            e.preventDefault();
            $focusableElements.eq(currentIndex - 1).focus();
        } else {
            // Move to previous tile
            navigateToPreviousTile($tile, e);
        }
    }

    /**
     * Navigate to next focusable element within tile or next tile
     */
    function navigateToNextElement($tile, $focusableElements, e) {
        if ($focusableElements.length === 0) {
            return;
        }

        var currentIndex = $focusableElements.index(document.activeElement);

        if (currentIndex < $focusableElements.length - 1) {
            e.preventDefault();
            $focusableElements.eq(currentIndex + 1).focus();
        } else {
            // Move to next tile
            navigateToNextTile($tile, e);
        }
    }

    /**
     * Navigate to previous tile
     */
    function navigateToPreviousTile($tile, e) {
        var slick = getSlickCarousel($tile);
        
        if (slick) {
            // Handle Slick carousel navigation
            e.preventDefault();
            var currentSlide = slick.currentSlide;
            var newSlide = currentSlide - 1;
            
            if (newSlide >= 0) {
                slick.slickGoTo(newSlide);
                // Focus the first focusable element in the new slide
                setTimeout(function() {
                    var $newSlide = $(slick.$slides[newSlide]);
                    var $focusable = $newSlide.find(focusableSelector).filter(':visible');
                    if ($focusable.length) {
                        $focusable.last().focus();
                    }
                }, 50);
            }
        } else {
            // Handle regular grid navigation
            var $visibleTiles = getAllVisibleTiles();
            var currentIndex = $visibleTiles.index($tile);

            if (currentIndex > 0) {
                e.preventDefault();
                var $prevTile = $visibleTiles.eq(currentIndex - 1);
                var $prevFocusable = getFocusableElements($prevTile);
                if ($prevFocusable.length) {
                    $prevFocusable.last().focus();
                } else {
                    $prevTile.focus();
                }
            }
        }
    }

    /**
     * Navigate to next tile
     */
    function navigateToNextTile($tile, e) {
        var slick = getSlickCarousel($tile);
        
        if (slick) {
            // Handle Slick carousel navigation
            e.preventDefault();
            var currentSlide = slick.currentSlide;
            var newSlide = currentSlide + 1;
            
            if (newSlide < slick.slideCount) {
                slick.slickGoTo(newSlide);
                // Focus the first focusable element in the new slide
                setTimeout(function() {
                    var $newSlide = $(slick.$slides[newSlide]);
                    var $focusable = $newSlide.find(focusableSelector).filter(':visible');
                    if ($focusable.length) {
                        $focusable.first().focus();
                    }
                }, 50);
            }
        } else {
            // Handle regular grid navigation
            var $visibleTiles = getAllVisibleTiles();
            var currentIndex = $visibleTiles.index($tile);

            if (currentIndex < $visibleTiles.length - 1) {
                e.preventDefault();
                var $nextTile = $visibleTiles.eq(currentIndex + 1);
                var $nextFocusable = getFocusableElements($nextTile);
                if ($nextFocusable.length) {
                    $nextFocusable.first().focus();
                } else {
                    $nextTile.focus();
                }
            }
        }
    }

    /**
     * Initialize keyboard navigation on product tiles
     */
    function init() {
        $(document).on('keydown', '.product-tile', handleTileKeydown);
    }

    return {
        init: init
    };
};
